'use strict';

import Vue from "vue";
import './components';
import './vee-validate';
import Search from "./mixins/Search";
import router from './router';

window.axios = require('axios');
window.Routes = require('./routes').default;

Vue.prototype.$eventBus = new Vue();

let vuejs = {
    app: null,
    init() {

        if ($('#app').length <= 0) {
            return;
        }

        this.app = new Vue({
            router,
            el: '#app',
            comments: true,
            mixins: [Search],
            data() {
                return {

                };
            },
            mounted() {
                // init Drupal
                window.Drupal.arrow.init();
            },
            methods: {

            }
        });

    }
};

export default vuejs;
